import type { Deal } from '@paintscout/api'
import type { ContactIndexDoc } from '@paintscout/util/database/elasticsearch/indexContact'
import type { Contact } from 'paintscout'

export function mapContactToDealContact(contact: ContactIndexDoc | Contact): Deal['contact'] {
  const contactId = (contact as ContactIndexDoc)?.id ?? (contact as Contact)?._id
  return {
    id: contactId,
    email: contact?.email ?? null,
    firstName: contact?.first_name ?? '',
    lastName: contact?.last_name ?? '',
    company: contact?.company ?? '',
    phoneNumber: contact?.phone_number ?? '',
    preferredContactMethod: contact?.preferred_contact_method ?? '',
    companyId: contact?.companyDocId ?? ''
  }
}
